export enum LFATrackEvents {
  LFA_SIGNUP_PHONE_SUBMISSION = 'LFAV2_signup_phone_submission',
  LFA_SIGNUP_ACCOUNT_SUBMISSION = 'LFAV2_signup_account_submission',
  LFA_SIGNUP_PHONE_ACTIVE_LICENCE = 'LFAV2_signup_phone_active_license',
  LFA_SIGNUP_PHONE_USED_FOR_TRIAL = 'LFAV2_signup_phone_used_for_trial',
  LFA_SIGNUP_ACCOUNT_ACTIVE_LICENSE = 'LFAV2_signup_account_active_license',
  LFA_SIGNUP_ACCOUNT_USED_FOR_TRIAL = 'LFAV2_signup_account_used_for_trial',
  LFA_SIGNUP_PHONE_CHOOSE_PLAN = 'LFAV2_signup_phone_choose_plan',
  LFA_SIGNUP_ACCOUNT_CHOOSE_PLAN = 'LFAV2_signup_account_choose_plan',
  LFA_SIGNUP_WELCOME_START = 'LFAV2_signup_welcome_start',
  LFA_SIGNUP_CHOOSE_PLAN_HELP = 'LFAV2_signup_choose_plan_need_help',
  LFA_SIGNUP_EXPIRED_HELP = 'LFAV2_help',
  LFA_SIGNUP_PERSONAL_INFO = 'LFAV2_signup_personal_info_submission',
  LFA_SIGNUP_CHECKOUT = 'LFAV2_checkout',
  LFA_SIGNUP_PHONE_VALIDATION_SUCCESSFUL = 'LFAV2_signup_phone_validation_successful',
  LFA_SIGNUP_PHONE_VALIDATION_UNSUCCESSFUL = 'LFAV2_signup_phone_validation_unsuccessful',
  LFA_SIGNUP_PHONE_VALIDATION_SENDCODE = 'LFAV2_signup_phone_validation_sendcode',
  LFA_LC_ONBOARDING_START = 'LFAV2_LC_onboarding_start',
  LFA_LC_ONBOARDING_STEP1_SAVE = 'LFAV2_LC_onboarding_step1_save',
  LFA_LEVEL_PLACED_IN_LEVEL_1 = 'LFAV2_level_placed_in_level_1',
  LFA_LEVEL_PLACEMENT_TEST = 'LFAV2_level_placement_test',
}
